import { connect } from 'react-redux'
import NetworkMessage from './NetworkMessage'
import { updateCart } from '../../cart/actions'
import { injectIntl } from 'react-intl'
import { bindActionCreators, Dispatch, Action } from 'redux'

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ updateCart }, dispatch)

export default injectIntl(
  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  connect(undefined, mapDispatchToProps)(NetworkMessage)
)
